import * as DialogPrimitive from '@radix-ui/react-dialog';
import { AnimatePresence, motion, useTransform } from 'framer-motion';
import { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { coreTokens } from '../../core';
import { IconButton } from '../icon_button';
import { Flex } from '../layout';
import { FileViewerContext } from './_file_viewer.context';
import { theme } from './file_viewer.theme';

const elements = {
	topBar: styled(motion.div)`
		position: absolute;
		z-index: 1;
		top: 0;
		left: 0;
		width: 100%;
		height: calc(${coreTokens.spacing.x1_5} + ${coreTokens.spacing.x6});
		padding: ${coreTokens.spacing.x1_5};
		display: flex;
		gap: ${coreTokens.spacing.x1_5};
		justify-content: space-between;
		align-items: center;
		background: ${theme.getValue('background')};
		box-sizing: border-box;

		${coreTokens.breakpointQuery.small} {
			gap: ${coreTokens.spacing.x2};
			padding: ${coreTokens.spacing.x2};
			height: calc(${coreTokens.spacing.x2} + ${coreTokens.spacing.x6});
		}
	`,
	description: styled.div`
		white-space: nowrap;
		text-overflow: ellipsis;
		overflow: hidden;
		font: ${coreTokens.text.label.regular};
	`,
};

export function CellulaFileViewerTopBar(_: unknown): JSX.Element {
	const { showBar, showBarManually, y, currentIndex, files } = useContext(FileViewerContext);
	const [description, setDescription] = useState<string | null>(null);
	const opacity = useTransform(y, [-70, 0, 70], [0, 1, 0]);

	useEffect(() => {
		const item = files[currentIndex];
		setDescription(item && item.description ? item.description : null);
	}, [files, currentIndex]);

	return (
		<AnimatePresence initial={false}>
			{showBar && showBarManually ? (
				<elements.topBar
					initial={{ y: '-100%' }}
					animate={{ y: 0 }}
					exit={{ y: '-100%' }}
					transition={{ duration: 0.4, ease: 'backInOut' }}
					style={{ opacity }}
				>
					<elements.description>{description}</elements.description>
					<DialogPrimitive.Close asChild>
						<Flex shrink={0} asChild>
							<IconButton icon='x' size='medium' text='Close' variant='on-dark' tooltipVariant='light' />
						</Flex>
					</DialogPrimitive.Close>
				</elements.topBar>
			) : null}
		</AnimatePresence>
	);
}
